import { useEffect } from "react";

import { Action, Category } from "constants/events";
import { useEventTracker } from "hooks/useEventTracker";

import Button from "components/botanic/Button";
import BagStylizedIcon from "components/Icons/bag_stylized.svg";

interface Props {
  label: string;
  href: string;
}

const EmptyBagMessage: React.FC<Props> = ({ label, href }) => {
  const { publishEvent } = useEventTracker();

  useEffect(() => {
    publishEvent({
      action: Action.impression,
      category: Category.emptyBagState,
    });
  }, []);

  return (
    <>
      <div className="pb-section pt-xxl" data-testid="empty-bag-alert">
        <div className="grid grid-rows-1 justify-center text-center">
          <div className="flex justify-center mb-lg">
            <BagStylizedIcon
              width="60"
              height="60"
              className="block relative z-10"
            />
          </div>
          <p className="mb-lg font-bold">Empty stash?</p>
          <p className="mb-lg">
            Let's fix that. Thousands of products at local, licensed shops near
            you.
          </p>
          <div className="flex justify-center w-full">
            <Button
              href={href}
              onClick={() => {
                publishEvent({
                  action: Action.click,
                  category: Category.emptyBagState,
                  label,
                });
              }}
              variant="secondary"
            >
              {label}
            </Button>
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 767px) {
          .empty-bag-container {
            min-height: 425px;
          }
        }
        `}</style>
    </>
  );
};

export default EmptyBagMessage;
